import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { useInvitationSearch } from '@/hooks/useInvitationSearch';
import { InvitationListContainer } from './InvitationListContainer';

export const OptimizedInvitationsManagement = React.memo(() => {
  const { inputValue, setInputValue, searchTerm } = useInvitationSearch();

  return (
    <div className="space-y-6">
      {/* Search */}
      <div className="relative max-w-sm">
        <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search invitations..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          className="pl-10"
        />
      </div>

      {/* Invitations List */}
      <InvitationListContainer searchTerm={searchTerm} />
    </div>
  );
});

OptimizedInvitationsManagement.displayName = 'OptimizedInvitationsManagement';